import {showDependsParams} from '../cabinet/show-custom-fields-params';

function initDeleteButtons()
{
  const columnsTypesSelects = document.querySelectorAll('.delete_custom_field_column');

  if (!columnsTypesSelects.length) {
    return;
  }
}

function changeColumnTypeHandler(e) {
  const columnTypeSelect = '3';
  const columnTypeCheckbox = '4';
  const currentOption = this.options[this.selectedIndex];
  const parentBlockClass = currentOption.getAttribute('data-parent-class');
  const parentBlock = currentOption.closest('.' + parentBlockClass);
  const columnVariantsBlock = parentBlock.querySelector('.custom-columns-variants-block');

  if (
    currentOption.value === columnTypeSelect ||
    currentOption.value === columnTypeCheckbox
  ) {
    columnVariantsBlock.classList.remove('d-none');
    columnVariantsBlock.classList.remove('d-none');
  } else {
    columnVariantsBlock.classList.add('d-none');
    columnVariantsBlock.classList.add('d-none');
  }
}

function initContestCustomFieldsColumns() {
  const columnsTypesSelects = document.querySelectorAll('.custom-field-column-types');

  if (!columnsTypesSelects.length) {
    return;
  }
  showDependsParams();
  columnsTypesSelects.forEach(function (typeSelect) {
    typeSelect.addEventListener('change', changeColumnTypeHandler);
  });

  initDeleteButtons();
}

export {initContestCustomFieldsColumns, changeColumnTypeHandler, initDeleteButtons}